import { ShieldX } from "lucide-react";
import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { GatewayPermission, useGatewayPermissions } from "../auth/permissions";

// PermissionRoute prevents hidden navigation targets from rendering through a direct URL.
// 防止用户通过直达地址打开前端未授权页面。
export function PermissionRoute({ permission, children }: { permission: GatewayPermission; children: ReactNode }) {
  const { can } = useGatewayPermissions();
  if (can(permission)) return children;

  return (
    <section className="permission-denied" aria-labelledby="permission-denied-title">
      <ShieldX size={28} />
      <div>
        <h1 id="permission-denied-title">无权访问此页面</h1>
        <p>当前 Keeper 角色没有这个页面的访问权限。</p>
      </div>
      <Link className="primary-button" to="/manage/overview">返回运行概览</Link>
    </section>
  );
}
